/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionCode } from '../../models/promotion-code';

export interface ApiMasterPromotionCodeGetByIdGet$Params {
  id?: string;
}

export function apiMasterPromotionCodeGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterPromotionCodeGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PromotionCode>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPromotionCodeGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromotionCode>;
    })
  );
}

apiMasterPromotionCodeGetByIdGet.PATH = '/api/Master/PromotionCode/GetById';
